import React from 'react';
import styles from './Pagination.module.css';

const Pagination = ({ 
  page, 
  pageSize, 
  totalItems, 
  filteredCount, 
  isSearching, 
  loading, 
  onPageChange 
}) => {
  const totalPages = Math.ceil(totalItems / pageSize) || 1;

  return (
    <div className={styles.paginationContainer}>
      <span className={styles.recordInfo}>
        Hiển thị: <strong>{filteredCount}</strong> / {isSearching ? filteredCount : totalItems} bản ghi
      </span>
      
      <div className={styles.pager}>
        <button 
          className={styles.btn}
          disabled={page <= 1 || loading} 
          onClick={() => onPageChange(page - 1)}
        >
          Trước
        </button>

        <span className={styles.activePage}>
          {page} / {totalPages}
        </span>

        <button 
          className={styles.btn}
          disabled={page * pageSize >= totalItems || loading} 
          onClick={() => onPageChange(page + 1)}
        >
          Sau
        </button>
      </div>
    </div>
  );
};

export default Pagination;